module.exports = __webpack_public_path__ + "img/thumbnail_PygmyHippo_f_normal.50d0237f.png";